import { State } from 'src/types'
import { thumbHook } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/back/thumbHook'
import { littleHook } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/back/littleHook'
import { laceDrawer } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/back/lace'
import { backStyleDrawer } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/back/backStyleDrawer'
import { atomsLabelDrawerForCatcherMitt, atomsLabelDrawerForCatcherMittLeftThrow } from 'src/features/brands/atoms/canvas/common/useCanvasHelper'
import { canvasResetter } from 'src/features/brands/atoms/canvas/common/canvasResetter'
import { catchFaceDrawer } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/back/catchFaceDrawer'
import { webDrawer } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/back/webDrawer'
import { fingerGuardDrawer } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/back/fingerGuardDrawer'
import { fingerEmbroideryDrawerLeftThrow } from './embroideryDrawer/finger'
import { liningDrawerLeftThrow } from './liningDrawer'
import { startInversion, undoInversion } from 'src/util/canvas'

export const atomsCanvasCatcherMittBackLeftThrow = (ctx: CanvasRenderingContext2D, state: State, canvasWidth: number): void => {
  // リセット
  canvasResetter(ctx)

  // 裏革
  liningDrawerLeftThrow(ctx, state, canvasWidth)
  startInversion(ctx, canvasWidth)

  // バックスタイル
  backStyleDrawer(ctx, state)

  // 捕球面側
  catchFaceDrawer(ctx, state.catchFace.color, state.stitch.color, state.baseModel.productNumber)

  // 指カバー・指当て
  fingerGuardDrawer(ctx, state)
  undoInversion(ctx, canvasWidth)

  // 親指、小指の刺繍
  fingerEmbroideryDrawerLeftThrow(ctx, state.embroideries)

  startInversion(ctx, canvasWidth)
  // ウェブ
  webDrawer(ctx, state)

  // 革紐
  laceDrawer(ctx, state.lace.color)

  // かけ紐
  thumbHook(ctx, state.thumbHook.color)
  littleHook(ctx, state.littleHook.color)

  undoInversion(ctx, canvasWidth)
  // ブランドのラベル
  switch (state.dominantArm.value) {
    case 'leftThrow':
      atomsLabelDrawerForCatcherMittLeftThrow(ctx, state)
      break
    default:
      atomsLabelDrawerForCatcherMitt(ctx, state)
      break
  }
}
